function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import { Debounce } from '@/utils/validate';
import { TRANSPORT_OPTIONS } from '../static';
import TimeSelect from './TimeSelect.vue';
import * as dangaoActApi from '@/api/dangaoActApi';
export default {
  components: {
    TimeSelect: TimeSelect
  },
  data: function data() {
    return {
      TRANSPORT_OPTIONS: TRANSPORT_OPTIONS,
      loading: false,
      visible: false,
      pram: {
        deliveryType: [],
        deliveryTimes: []
      },
      initLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(tagDetails) {
      var _this$pram;
      this.pram = _objectSpread({
        deliveryType: [],
        deliveryTimes: [],
        source: 1
      }, tagDetails);
      if ((_this$pram = this.pram) !== null && _this$pram !== void 0 && _this$pram.id) {
        this.getBrandDetail();
      }
      ;
      this.visible = true;
    },
    getBrandDetail: function getBrandDetail() {
      var _this = this;
      this.initLoading = true;
      dangaoActApi.getDetailBrand(this.pram.id).then(function (res) {
        var _ref = res || {},
          deliveryType = _ref.deliveryType,
          deliveryTimes = _ref.deliveryTimes,
          brandAlbum = _ref.brandAlbum;
        var times = [];
        try {
          var _times;
          times = deliveryTimes && JSON.parse(deliveryTimes);
          times = (_times = times) === null || _times === void 0 ? void 0 : _times.map(function (item) {
            var _item$split = item === null || item === void 0 ? void 0 : item.split('-'),
              _item$split2 = _slicedToArray(_item$split, 2),
              startTime = _item$split2[0],
              endTime = _item$split2[1];
            return {
              startTime: startTime,
              endTime: endTime
            };
          });
        } catch (error) {}
        ;
        _this.pram = _objectSpread(_objectSpread({}, res), {}, {
          deliveryType: (deliveryType === null || deliveryType === void 0 ? void 0 : deliveryType.split(',')) || [],
          deliveryTimes: times || [],
          brandAlbum: (brandAlbum === null || brandAlbum === void 0 ? void 0 : brandAlbum.split(',')) || []
        });
        _this.initLoading = false;
      }).catch(function (err) {
        _this.initLoading = false;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref2 = _this2.pram || {},
          _ref2$brandAlbum = _ref2.brandAlbum,
          brandAlbum = _ref2$brandAlbum === void 0 ? [] : _ref2$brandAlbum,
          _ref2$deliveryTimes = _ref2.deliveryTimes,
          deliveryTimes = _ref2$deliveryTimes === void 0 ? [] : _ref2$deliveryTimes,
          _ref2$deliveryType = _ref2.deliveryType,
          deliveryType = _ref2$deliveryType === void 0 ? [] : _ref2$deliveryType;
        var timeLists = deliveryTimes !== null && deliveryTimes !== void 0 && deliveryTimes.length ? deliveryTimes === null || deliveryTimes === void 0 ? void 0 : deliveryTimes.map(function (item) {
          var _ref3 = item || {},
            startTime = _ref3.startTime,
            endTime = _ref3.endTime;
          return "".concat(startTime, "-").concat(endTime);
        }) : [];
        dangaoActApi.updateBrand(_objectSpread(_objectSpread({}, _this2.pram), {}, {
          brandAlbum: brandAlbum !== null && brandAlbum !== void 0 && brandAlbum.length ? brandAlbum === null || brandAlbum === void 0 ? void 0 : brandAlbum.join(',') : '',
          deliveryTimes: JSON.stringify(timeLists),
          deliveryType: deliveryType !== null && deliveryType !== void 0 && deliveryType.length ? deliveryType === null || deliveryType === void 0 ? void 0 : deliveryType.join(',') : ''
        })).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        if (tit == '2') {
          var _this3$pram, _this3$pram$dataIndex;
          if (img.length > 10) return _this3.$message.warning('最多选择10张图片！');
          if (img.length + (((_this3$pram = _this3.pram) === null || _this3$pram === void 0 ? void 0 : (_this3$pram$dataIndex = _this3$pram[dataIndex]) === null || _this3$pram$dataIndex === void 0 ? void 0 : _this3$pram$dataIndex.length) || 0) > 10) return _this3.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            var _this3$pram$dataIndex2;
            var list = (_this3$pram$dataIndex2 = _this3.pram[dataIndex]) !== null && _this3$pram$dataIndex2 !== void 0 && _this3$pram$dataIndex2.length ? _this3.pram[dataIndex] : [];
            list.push(item.sattDir);
            _this3.$set(_this3.pram, dataIndex, list);
          });
        } else if (tit == '1') {
          _this3.$set(_this3.pram, dataIndex, img[0].sattDir);
        }
        ;
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex, idx) {
      if (idx == -1) {
        this.$set(this.pram, dataIndex, '');
      } else {
        var _this$pram2, _this$pram2$dataIndex;
        (_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? void 0 : (_this$pram2$dataIndex = _this$pram2[dataIndex]) === null || _this$pram2$dataIndex === void 0 ? void 0 : _this$pram2$dataIndex.splice(idx, 1);
      }
    }
  }
};